import { FC, useState } from "react";
import svgIcons from "../../../assets/svg/svgIcons";

type TWidgetFilterSelectorProps = {
  limitWidth?: boolean;
  filter?: string; // deprecated
  selectedFilter?: string; // deprecated
  filters?: { label: string, value: string }[];
  setFilter?: (filterValue: string) => void;
  selectedFilterLabel?: string;
};

const WidgetFilterSelector: FC<TWidgetFilterSelectorProps> = ({
  limitWidth = true,
  filter, // deprecated
  selectedFilter, // deprecated
  filters,
  setFilter,
  selectedFilterLabel,
}) => {
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  return (
    <div className={`relative ${limitWidth ? "flex-grow peer-[]:max-w-[calc(100%-141px)]" : "max-w-1/3"}`}>
      <button
        className={`flex items-center gap-2 ps-4 pe-2 ms-[2px] h-10 rounded-lg relative ${showDropdown ? 'bg-accent-blue-pale z-popup' : ''} ${!!setFilter ? 'bg-black/5 hover:bg-accent-blue-pale' : 'pointer-events-none touch-none'} -ml-2 ${limitWidth ? "w-auto max-w-full" : ""}`}
        onClick={() => setShowDropdown(!showDropdown)}
      >
        <span className="text-heading-gray666 text-sm overflow-hidden whitespace-nowrap text-ellipsis">
          {selectedFilterLabel}
        </span>
        {!!setFilter && (<img
          className="size-6 rotate-90 -ml-1 contrast-50 invert"
          src={svgIcons.ChevronRight}
          alt="chevron right"
        />)}
      </button>
      {showDropdown && (
        <>
          <div className="fixed top-0 left-0 w-full h-screen bg-white/70 backdrop-blur-[1px] z-popup-overlay" onClick={() => setShowDropdown(false)}></div>
          <div className={`absolute z-popup top-full mt-2 -left-2 border border-black/10 flex flex-col gap-1 w-64 p-2 bg-white shadow-lg rounded-lg`}>
            {filters?.map((filter, index) => (
              <button
                type="button"
                key={index}
                className={`text-left text-sm px-4 py-2 rounded-lg ${filter.value === selectedFilter || filter.label === selectedFilterLabel ? 'text-heading-gray888/70 cursor-default' : ' hover:bg-accent-blue-pale text-heading-gray666'}`}
                onClick={() => {
                  setFilter?.(filter.value);
                  setShowDropdown(false);
                }}
                disabled={filter.value === selectedFilter}
              >
                {filter.label}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  )
}
export default WidgetFilterSelector;